import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import type { MergeFieldIssue } from '../constants/merge-field-issue.constants';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';

type MergeFieldIssuesBannerProps = {
  className?: string;
  issues: MergeFieldIssue[];
  rulesMessageId?: 'MERGE_FIELD_PLACEHOLDER_RULES' | 'QUICK_SIGN_MERGE_FIELD_PLACEHOLDER_RULES';
};

export const MergeFieldIssuesBanner: FC<MergeFieldIssuesBannerProps> = ({
  className,
  issues,
  rulesMessageId = 'MERGE_FIELD_PLACEHOLDER_RULES',
}) => {
  if (issues.length === 0) return null;

  return (
    <div
      className={twMerge(
        'rounded-lg border border-fireside-200 bg-fireside-25 px-4 py-3',
        className,
      )}
      role="alert"
    >
      <p className="text-sm font-medium text-fireside-700">
        <AppFormattedMessage id="MERGE_FIELD_ISSUES_TITLE" />
      </p>
      <p className="mt-2 text-xs leading-relaxed text-gray-700">
        <AppFormattedMessage id={rulesMessageId} />
      </p>
      <p className="mt-3 text-xs font-medium text-gray-800">
        <AppFormattedMessage id="MERGE_FIELD_INVALID_IN_FILE" />
      </p>
      <ul className="mt-1.5 list-disc space-y-1 pl-5 text-xs text-gray-700">
        {issues.map((issue, index) => (
          <li key={`${issue.field}-${issue.code}-${index}`}>
            <code className="break-all rounded bg-white/80 px-1 py-0.5 text-[11px]">
              {issue.field}
            </code>
          </li>
        ))}
      </ul>
    </div>
  );
};
